
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import AttachmentsList from '@/components/AttachmentsList.vue';
import TaskStatusAlert from '@/components/TaskStatusAlert.vue';
import TaskActions from '@/components/TaskActions.vue';

@Component({
  components: {
    AttachmentsList,
    TaskStatusAlert,
    TaskActions,
  },
})
export default class Step2 extends Vue {
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;

  loading = false
  valid = false
}
